

//   function resolveAfterNextBtn() {
//   	return new Promise((resolve, reject) => {
//     let nextBtnSlider = document.querySelector(".flickity-button.next");
    
//     while(!nextBtnSlider){

//       nextBtnSlider = document.querySelector(".flickity-button.next");
//     }
    
//     resolve(nextBtnSlider); 
//   }); 
//   }

//   function resolveAfterPrevBtn() { 
//     return new Promise((resolve, reject) => {
//     let prevBtnSlider = document.querySelector(".flickity-button.previous");
    
//     while(!prevBtnSlider){

//       prevBtnSlider = document.querySelector(".flickity-button.previous");
//     }
    
//     resolve(prevBtnSlider); 
//   }); 
//   }


function updateDropDown(btnSlider){
 
    btnSlider.addEventListener("click",function(){
     console.log("ct")
    let activeThumbnail = document.querySelector(".product-gallery__image.is-selected"); 
    let variantThumbTitle = activeThumbnail.getAttribute("data-variant-title"); 
    let imgThumbAlt = activeThumbnail.getAttribute("data-title");
    let dropdownSelect = document.getElementsByClassName("single-option-selector")[0]; 
    
    for (option of dropdownSelect ){
      if(option.value == imgThumbAlt || option.value == variantThumbTitle){
        option.selected = true; 
       
        let price = activeThumbnail.getAttribute("data-variant-price"); 
        let priceHost = document.querySelector('.product__price-container .product__price .current-price .money'); 
        priceHost.innerHTML = price; 
        
        /* MATCH hidden and visible dropdown values */
        const hiddenDropdown = document.querySelector(".hidden_dropdown") 
        const selectedVisibleOption = option.dataset.img
        
        hiddenDropdown.forEach(el => {
          /*Remove selected prevoius*/
          if(el.getAttribute("selected", true)){
            el.setAttribute("selected", false)
          }
         
          /*Match values*/
          if(el.dataset.secondary === selectedVisibleOption){
            el.setAttribute("selected", true)
          }
        })
        
      }
 
    }
     
   

    

    
  }); 
}

const observerNext = new MutationObserver((mutations, obs) => {
  const nextBtnSlider = document.querySelector(".flickity-button.next");
  if (nextBtnSlider) {
    updateDropDown(nextBtnSlider); 
    obs.disconnect();
    return;
  }
});

const observerBack = new MutationObserver((mutations, obs) => {
  const prevBtnSlider = document.querySelector(".flickity-button.previous");
  if (prevBtnSlider) {
    updateDropDown(prevBtnSlider); 
    obs.disconnect();
    return;
  }
});

observerNext.observe(document, {
  childList: true,
  subtree: true
});
observerBack.observe(document, {
  childList: true,
  subtree: true
});



  

// async function f1(){
  
//   let nextSlider = await resolveAfterNextBtn(); 

// } 
  
// async function f2(){ 
//   let prevSlider = await resolveAfterPrevBtn(); 
//   prevSlider.addEventListener("click",function(){
//     let activeThumbnail = document.querySelector(".product-gallery__image.is-selected"); 
//     let variantThumbTitle = activeThumbnail.getAttribute("data-variant-title"); 
//     let imgThumbAlt = activeThumbnail.getAttribute("data-title");
//     let dropdownSelect = document.getElementsByClassName("single-option-selector")[0]; 
    
//     for (option of dropdownSelect ){
//       if(option.value == imgThumbAlt || option.value == variantThumbTitle){
//         option.selected = true; 
//       }
 
//     }
    

    
//   }); 
// }


// f1();
// f2(); 